/* fx-vin.js: the one thing the VIN matched phone screen needs that CSS cannot do.
   The stylesheet shrinks "VIN Matched" to an eyebrow and hides the production
   records sentence. This puts that sentence somewhere it can still be read, in
   a tooltip beside the eyebrow, and marks the header so the stylesheet knows a
   match is what it is looking at.

   Built on every pass rather than stamped once: the extension rewrites this
   heading's textContent whenever it resets the header, which takes the tooltip
   with it. A stamp would survive that and the tooltip would not. */
(function () {
  "use strict";

  var frame = 0;

  function vinTip() {
    var h2 = document.getElementById("vinModalTitle");
    var p = document.getElementById("vinModalDescription");
    if (!h2) return;

    var head = h2.closest(".vin-modal-header");
    /* The green tick is the extension's own marker for a matched VIN, and it
       survives a locale change in a way the word "Matched" does not. */
    var matched = !!h2.querySelector(".vin-header-check");
    if (head) head.classList.toggle("fx-matched", matched);
    if (!matched || !p) return;

    var text = (p.textContent || "").trim();
    if (!text) return;

    var tip = h2.querySelector(".fx-vtip");
    if (!tip) {
      tip = document.createElement("span");
      tip.className = "fx-vtip";
      tip.setAttribute("tabindex", "0");
      tip.setAttribute("role", "note");
      tip.appendChild(document.createTextNode("i"));
      tip.appendChild(document.createElement("span")).className = "fx-vtip__box";
      h2.appendChild(tip);
    }

    var box = tip.querySelector(".fx-vtip__box");
    if (box && box.textContent !== text) {
      box.textContent = text;
      tip.setAttribute("aria-label", text);
    }
  }

  function tick() {
    frame = 0;
    vinTip();
  }

  function schedule() {
    if (frame) return;
    frame = setTimeout(tick, 40);
  }

  function start() {
    tick();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "hidden"]
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
